import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";
import { getDateRangeForTimeFrame } from "@/_utility/date.utils";
import { GroupFilterOptions } from "@/_models/filters/group-filter-options";

@Component({
    selector: "app-insights-filter-sidebar",
    templateUrl: "./insights-filter-sidebar.component.html",
    styleUrls: ["./insights-filter-sidebar.component.scss"],
})
export class InsightsFilterSidebarComponent implements OnInit {
    @Input() filterForm: UntypedFormGroup;
    @Output() closeButtonClicked: EventEmitter<void> = new EventEmitter<void>();

    @Input() userList: RadioOption[];
    @Input() statusList;
    @Input() timeFrameList: RadioOption[];
    @Input() formType: RadioOption[];
    @Input() aircraftList: RadioOption[];
    @Input() formList: RadioOption[];
    @Input() groupFilterOptions: GroupFilterOptions;

    showDateRangeFilterModal = false;
    dateRangeFilterControl: UntypedFormControl;
    private dateRangeTimeFrameControl: UntypedFormControl;

    ngOnInit() {}

    setDateRangeValue(control: UntypedFormControl, value: any) {
        control.setValue(value);
        if (value === "") {
            return this.filterForm.get("flightDate").setValue("");
        }
        if (value === "custom") {
            this.dateRangeTimeFrameControl = control;
            this.dateRangeFilterControl = this.filterForm.get(
                "flightDate",
            ) as UntypedFormControl;
            this.showDateRangeFilterModal = true;
            return;
        }
        const range = getDateRangeForTimeFrame(value);
        if (range) {
            return this.filterForm.get("flightDate").setValue(range);
        }
    }

    onDateRangeFilterModalVisibleChange(visible: boolean) {
        this.showDateRangeFilterModal = visible;
        if (
            !visible &&
            !this.filterForm.get("flightDate").value?.length &&
            this.dateRangeTimeFrameControl
        ) {
            this.setDateRangeValue(this.dateRangeTimeFrameControl, "");
        }
    }

    setCheckboxValue(control: UntypedFormControl, state: boolean, value: any) {
        if (state) {
            return control.setValue([...control.value, value]);
        }
        return control.setValue([
            ...control.value.filter((currentValue) => currentValue !== value),
        ]);
    }

    close() {
        this.closeButtonClicked.emit();
    }
}
